/**
 * Rôle du user connecté uniquement.
 * Récupère le rôle effectif depuis le storage (refPortalRole si renseigné, sinon fonction).
 * @returns {string} Rôle du user connecté, ou chaîne vide si non défini
 */
export function getConnectedUserRole() {
  let userRole = localStorage.getItem('userRole') || '';
  console.log('Connected user Role: ', userRole);
  return userRole;
}
